module.exports = __webpack_public_path__ + "img/admin-activate-btn.9dc1b79e.webp";